import { UserType } from "@/api/query/useCurrentUserQuery";
import { ExtendPlanTypeEnumSchema, PlanTypeEnumSchema } from "@backend/src/schemas/enums";

/**
 * Checks if the Timesheet feature is accessible for the given user.
 * Accessible if:
 * 1. User has an ENTERPRISE subscription.
 * 2. User is within the 14-day free trial period.
 */
export const isTimesheetAccessible = (user: UserType | null | undefined): boolean => {
  if (!user) return false;

  // 1. Check for Enterprise plan
  if (user.subscription?.planType === PlanTypeEnumSchema.ENTERPRISE) {
    return true;
  }

  // 2. Check for 14-day free trial via customerId
  if (user.subscription?.customerId === ExtendPlanTypeEnumSchema.FREE_TRIAL) {
    return true;
  }

  // 3. Check for 14-day free trial via provider creation date
  // We use the first provider's FreeTrialCreatedAt as the start of the trial
  const trialStartDateStr = user.provider?.[0]?.FreeTrialCreatedAt;
  if (trialStartDateStr) {
    const trialStartDate = new Date(trialStartDateStr);
    const now = new Date();
    
    // Calculate difference in days
    const diffTime = Math.abs(now.getTime() - trialStartDate.getTime());
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    
    if (diffDays <= 14) {
      return true;
    }
  }

  return false;
};
